import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, Button, CircularProgress } from '@material-ui/core';
import { useContext } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { newRegistrationContext } from '../../NewRegistrationContext';
import Summary from './Summary';
import Completed from './Completed';


let ConfirmRegistration = () => {
    let history = useHistory();

    let service = useContext(newRegistrationContext);


    return (
        <Dialog
            open={service.isSummaryOpen}
            maxWidth="lg"
            fullWidth={true}
            scroll="paper"
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle disableTypography id="form-dialog-title">
                <Typography variant="h3">
                    <Box fontWeight="fontWeightLight">Confirm product registration</Box>
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                {service.isSaved === false && <Summary registration={service.registration} />}
                {service.isSaved === true && service.registrationCompleted && <Completed response={service.registrationCompleted} />}
            </DialogContent>
            <DialogActions>
                {service.isSaved === false &&
                    <>
                        {service.isSaving && <CircularProgress size={24} />}
                        <Button
                            disabled={service.isSaving}
                            onClick={service.closeSummary}
                            variant="outlined"
                            color="secondary"
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={service.confirmRegistration}
                            disabled={service.isSaving}
                        >
                            Confirm
                        </Button>
                    </>
                }
                {service.isSaved === true &&
                    <>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={() => history.go(0)}
                        >
                            New Registration
                        </Button>
                        <Button
                            component={RouterLink}
                            variant="contained"
                            color="primary"
                            to={`/registration/${service.registrationCompleted?.registrationId}`}
                        >
                            View Registration
                        </Button>
                    </>
                }
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmRegistration;